export enum ConsentTriggerEvent {
  Show = 'show'
}
